import { GameSettingTypesEnum } from '../../enums';

export const GAME_WRAPPER_MAX_WIDTH: Partial<Record<GameSettingTypesEnum, number>> = {
  [GameSettingTypesEnum.TIC_TAC_TOE]: 900,
  [GameSettingTypesEnum.SLIDING_PUZZLE]: 900
};
